import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Collapse, IconButton } from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import SettingsService from '../../../../services/SettingsService/SettingsService';
import ScheduleBackup from './ScheduleBackup';
import Logging from './Logging';
import SysLog from './SysLog';
import {useSetRecoilState} from 'recoil';
import { alertState } from '../../../../recoil-store/recoil-state';
import './General.css';

/**
 * @Description This function lets you return General Settings page.
 * @Returns     Component
 * @Author      ibrahim AKIN
 */

function Row({ name, children }) {
    const { t } = useTranslation();
    const label = 'CONTENT.SETTINGS.GENERAL.';
    const [open, setOpen] = useState(false);
    const [status, setStatus] = useState(false);

    const handleChange = (e) => {
        let checked = e.target.checked;
        if (checked) {
            setOpen(true);
        } else if (open) {
            setOpen(false);
        }
        setStatus(checked);
    }

    const handleClick = (e) => {
        setOpen(!open);
    }

    return (
        <div className="sgeneral-section">
            <div className="sgeneral-row">
                <div>
                    <div>
                        <span className="sgeneral-header">{t(label + name)}</span>
                        <label className="switch small">
                            <input type="checkbox" checked={status} onChange={handleChange}/>
                            <span className="slider round red"></span>
                        </label>
                    </div>
                    <div>
                        <IconButton size="small" onClick={handleClick} disabled={!status}>
                            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                        </IconButton>
                    </div>
                </div>
            </div>
            <Collapse in={open} timeout="auto" unmountOnExit>{children}</Collapse>
        </div>
    );
}

function GeneralSettings(props) {
    const { t } = useTranslation();
    const label = 'CONTENT.SETTINGS.GENERAL.';
    const setAlert = useSetRecoilState(alertState);
    const restoreDefault = () => {
        // TODO restore default settings
    }
    const resetDefault = async () => {
        const res = await SettingsService.resetSettings();
        if (res) { 
            setAlert(alert => ({ ...alert, show: true, message: t(label + res.message), severity:res.status ? 'success': 'error' }));

        }
    }
    return (
        <div className="sgeneral">
            <div>{t(label + 'GENERAL')}</div>
                <Row name="SCHEDULE"><ScheduleBackup/></Row>
                <Row name="LOGGING"><Logging/></Row>
                <Row name="SYSLOG"><SysLog/></Row>
            <div className="sgeneral-divider"></div>
            <div className="bottom-row">
                <button className="sgeneral-save">{t(label + 'SAVE')}</button>
                <div>
                    <button className="button-restore" onClick={restoreDefault}>
                        {t(label + 'RESTORE')}
                    </button>
                    <button className="button-restore button-reset" onClick={resetDefault}>
                        {t(label + 'RESET')}
                    </button>
                </div>
            </div>
        </div>
    );
}
export default GeneralSettings;